import { render, staticRenderFns } from "./StockHistory.vue?vue&type=template&id=3ccd11f8&scoped=true&"
import script from "./StockHistory.vue?vue&type=script&lang=js&"
export * from "./StockHistory.vue?vue&type=script&lang=js&"
import style0 from "./StockHistory.vue?vue&type=style&index=0&lang=css&"
import style1 from "./StockHistory.vue?vue&type=style&index=1&id=3ccd11f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccd11f8",
  null
  
)

export default component.exports